/**
 * The two enumerations a profile form offers, which are not copy.
 *
 * They lived inside `policy-strings.ts` and had to leave it when the catalogue became
 * locale-keyed (PRD-27 F-20, D-25, LOC-017). A model alias and a retrieval strategy are wire
 * identifiers — `ModelAliasSchema` and the policy body's `strategy` are what the server
 * validates against — so they are never translated (D-17), and a pt-BR copy of a catalogue
 * that happened to contain them would offer Portuguese readers a different set of models
 * than everybody else, which is a routing change disguised as a translation.
 */

export const MODEL_ALIASES = ['fast', 'balanced', 'deep_reasoning', 'embedding'] as const

export const RETRIEVAL_STRATEGIES = ['hybrid', 'semantic', 'lexical'] as const
